/* eslint-disable css-modules/no-undef-class, css-modules/no-unused-class, no-nested-ternary */
import { FC, useState } from 'react';
import { Icon, Tabs } from 'learning-panel-components';
import { translate } from 'translations';
import { coreService } from 'network-utils';
import LeaderboardItem from '../leaderboardItem/leaderboardItem';
import styles from './leaderboardExpand.module.scss';

const LeaderboardExpand: FC<LeaderboardExpandProps> = (props: LeaderboardExpandProps) => {
    const { teamsLeaderboard, users, onFullExpand, onUnexpanded, onlyUsers } = props;
    const [currentTabId, setCurrentTabId] = useState<number>(TabsType.users);

    const calcTabs = () => {
        if (onlyUsers || teamsLeaderboard.length === 0) {
            return [{ id: TabsType.users, title: translate('Users') }];
        }
        return [
            { id: TabsType.users, title: translate('Users') },
            { id: TabsType.teams, title: translate('Teams') }
        ];
    };

    const getItems = () => {
        return currentTabId === TabsType.users ? users : teamsLeaderboard;
    };

    return (
        <div data-testid="leaderboard" className={styles['leaderboard-wrapper']}>
            <div className={styles.top}>
                <div className={styles.title}>{translate('Leaderboard')}</div>
                <div className={styles['icons-wrapper']}>
                    <div
                        onClick={() => {
                            onFullExpand(true);
                            onUnexpanded(false);
                        }}
                    >
                        <Icon data-testid="arrow-icon" name={'upDownExpand'} className={styles.icon} />
                    </div>
                    <div
                        onClick={() => {
                            onUnexpanded(false);
                            onFullExpand(false);
                        }}
                    >
                        <Icon data-testid="arrow-icon" name={'close'} className={styles.icon} />
                    </div>
                </div>
            </div>
            <div className={styles['tabs-wrapper']}>
                <Tabs currentTabId={currentTabId} onTabClick={setCurrentTabId} tabs={calcTabs()} />
            </div>
            <div className={styles.items}>
                {getItems()?.map((item, index) => (
                    <LeaderboardItem {...item} key={index} />
                ))}
            </div>
        </div>
    );
};

interface LeaderboardExpandProps {
    users: coreService.HomeUserLeaderboard[];
    teamsLeaderboard: coreService.HomeTeamLeaderboard[];
    onUnexpanded: Function;
    onFullExpand: Function;
    onlyUsers: boolean;
}

enum TabsType {
    users,
    teams
}

export default LeaderboardExpand;
